export const GET_DADOS_RELATORIO = 'GET_DADOS_RELATORIO'
